import styled from 'styled-components';

export default function CalendarLegend() {
  return (
    <Container>
      <LegendItem>
        <Dot $color='medicare' />
        <Label>Medicare</Label>
      </LegendItem>
      <LegendItem>
        <Dot $color='other' />
        <Label>Other</Label>
      </LegendItem>
    </Container>
  );
}

const Container = styled.div`
  display: flex;
  align-items: center;
  gap: 24px;
`;

const LegendItem = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

const Dot = styled.span<{ $color: 'medicare' | 'other' }>`
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: ${({ $color, theme }) =>
    $color === 'medicare' ? theme.colors.green100 : theme.colors.lightBlue100};
`;

const Label = styled.span`
  font-size: 12px;
  color: ${({ theme }) => theme.colors.black100};
`;
